<template>
  <q-carousel
    v-if="movies.length !== 0"
    v-model="slide"
    :autoplay="showTrailer ? 20000 : 10000"
    infinite
    :style="{ 'max-height': !isFullScreen ? $isLandscapeView() ? '45vh' : '35vh' : undefined }"
  >
    <q-carousel-slide
      v-for="(showings, movieId) in movies"
      :key="movieId"
      :name="movieId"
      :img-src="isFullScreen && !$isLandscapeView() ? showings[0].movie.posterImageUrl : showings[0].movie.bannerImageUrl "
    >
      <template
        v-if="showings[0].movie.trailerYoutubeId && !!showTrailer"
      >
        <q-video
          class="absolute-full"
          style="top: 0; right: 0; bottom: 0; left: 0; margin: auto;pointer-events: none; "
          :style="{ 'transform': isFullScreen ? $isLandscapeView() ? 'scale(1.8)' : 'scale(4)' : 'scale(1.5)' }"
          :ratio="16/9"
          :src="'https://www.youtube.com/embed/' + showings[0].movie.trailerYoutubeId + '?controls=0&autoplay=1&loop=1&mute=1&showinfo=0&rel=0&disablekb=1&modestbranding=1&cc_load_policy=3&allowsInlineMediaPlayback=1&playlist='+ showings[0].movie.trailerYoutubeId"
        />
      </template>
      <q-footer
        v-if="!cleanImage"
        style=" background: linear-gradient(transparent, rgba(0, 0, 0, 0.7)); position: absolute; bottom: 0px; "
        class="q-pa-sm row z-top"
      >
        <div class="col-9">
          <div
            class="text-bold text-h5"
          >
            {{ showings[0].movie.name }}
            <rated
              v-if="showings[0].movie.rating"
              :rated="showings[0].movie.rating"
              :rating-reason="showings[0].movie.ratingReason"
              :outline="false "
              :color="'white'"
              :text-color="'dark'"
              :size="'md'"
              class="text-bold q-px-sm"
            />
          </div>
          <div
            class="text-subtitle2"
            style="line-height: 1;"
          >
            {{ $t('time.startsOn', { time: showings[0].time.relativeTime() }) }}
          </div>
        </div>
        <q-btn
          v-if="allowBuyTickets"
          :label="$_.toUpper($tc('ticket.actions.buy', 2))"
          :name="movieId"
          size="md"
          class="col-3 z-max"
          outline
          rounded
          @click="() => $emit('movie-selected', showings[0].movie.id.toString())"
        />
      </q-footer>
    </q-carousel-slide>
  </q-carousel>
  <div
    v-else-if="!isFullScreen"
    class="column items-center justify-center"
    style="height: 100%;"
  >
    <h1
      class="text-h3 text-bold q-mt-lg q-pa-md relative-position text-center q-mb-none"
      :class="$q.dark.isActive ? 'text-white' : 'text-primary'"
    >
      {{ $t('kiosk.selfServiceKiosk') }}
      <span
        v-if="$q.dark.isActive"
        class="block absolute-full bg-primary"
        style="opacity: 0.5; z-index: -1;"
      />
    </h1>
    <h1
      class="text-h3 text-bold q-pa-md relative-position text-center q-mt-none"
      :class="$q.dark.isActive ? 'text-white' : 'text-primary'"
    >
      {{ $t('kiosk.selectActionToStart') }}
      <span
        v-if="$q.dark.isActive"
        class="block absolute-full bg-primary"
        style="opacity: 0.5; z-index: -1;"
      />
    </h1>
  </div>
</template>
<script>

import { imgixHost } from 'src/config'
import Rated from 'src/modules/consumer/components/Rated'
export default {
  name: 'PlayingTodayCarousel',
  components: {
    Rated
  },
  models: {
    site: {
      todaysShowings: {
        movie: 'default',
        screen: 'default',
        showingBadges: 'default'
      },
      variables () {
        return {
          id: this.currentSite.id
        }
      },
      immediate: true
    }
  },
  props: {
    delayInSeconds: {
      type: Number,
      required: false,
      default: 6
    },
    autoplay: {
      type: Boolean,
      required: false,
      default: true
    },
    isFullScreen: {
      type: Boolean,
      required: false,
      default: false
    },
    cleanImage: {
      type: Boolean,
      required: false,
      default: false
    },
    showTrailer: {
      type: Boolean,
      required: false,
      default: true
    },
    allowBuyTickets: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ['movie-selected'],
  data () {
    return {
      slide: 1,
      moviesIntervalId: null
    }
  },
  computed: {
    movies () {
      if (!this.site) return

      return _(this.site.todaysShowings.data)
        .filter(showing => !showing.past)
        .groupBy('movie.id')
        .sortBy(showings => -showings.length) // Second priority is number of showings
        .sortBy(showings => showings[0].screen.displayOrder) // First priority is what screen it is in
        .value()
    }
  },
  mounted () {
    this.moviesIntervalId = setInterval(() => {
      this.site.fetch(true)
    }, 10 * 60 * 1000)
  },
  beforeUnmount () {
    if (this.moviesIntervalId) {
      clearTimeout(this.moviesIntervalId)
    }
  },
  created () {
    _.extend(this, { imgixHost })
  },
  context: ['currentUser'],
  configuration: ['currentSite']
}
</script>
<style lang="scss" scoped>

</style>
